import React from "react";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { RouterTextLink } from "components/actions/RouterLink";
import SrcDocsLink from "components/actions/SrcDocsLink";
import Divider from "components/ui/divider/Divider";
import TooltipComponent from "components/ui/tooltip/Tooltip";
import { appRoutes } from "lib/appRoutes";
import UIcon from "lib/icons/untitled_ui/UIcon";

const tooltipContent =
  "Duplicate notices are notices which have been found from other sources but for the same procurement";

export type Duplicate = {
  guid: string;
  name: string;
  url: string;
};

export default function NoticeDuplicatesProperty({ duplicates }: { duplicates: Duplicate[] }) {
  const { colors } = useTheme();
  return (
    <>
      <Divider />
      <Flex gap={8} alignItems="flex-start">
        <TitleContainer>
          <Text color={colors.sysTextSecondary}>Duplicates</Text>
          <TooltipComponent content={tooltipContent}>
            <InfoButton>
              <UIcon icon="infoCircle" size={16} color="inherit" />
            </InfoButton>
          </TooltipComponent>
        </TitleContainer>
        <DuplicatesContainer>
          {duplicates.map(({ guid, name, url }) => (
            <Flex key={guid} column>
              <RouterTextLink {...appRoutes.noticeDetail(guid)} ellipsis>
                {name}
              </RouterTextLink>
              <SrcDocsLink url={url} linkType="text" showIcon={false} secondary ellipsis />
            </Flex>
          ))}
        </DuplicatesContainer>
      </Flex>
    </>
  );
}

const TitleContainer = styled(Flex)({
  alignItems: "center",
  minWidth: "30%",
});

const DuplicatesContainer = styled(Flex)({
  flexDirection: "column",
  gap: 16,
  minWidth: "70%",
});

const InfoButton = styled.button(({ theme }) => ({
  backgroundColor: "transparent",
  border: "none",
  color: theme.colors.sysTextPlaceholder,
  display: "flex",
  alignItems: "center",
}));
